module.exports = __webpack_public_path__ + "img/locked.2807e399.svg";